import config from '../config'

import Link from '../../../commons/src/components/link'
import Footer from '../components/footer'

const FooterPartial = () => (
  <Footer
    copyline={
      <>
        © <strong>{new Date().getFullYear()}</strong> Craftcloud®
      </>
    }
  >
    <Link href={`mailto:${config.emails.partner}`}>Contact us</Link>
    <Link target="_blank" href="/assets/documents/Craftcloud - Partner Terms & Conditions.pdf">
      Terms and conditions
    </Link>
    <Link target="_blank" href="https://all3dp.com/imprint/">
      Imprint
    </Link>
  </Footer>
)

export default FooterPartial
